import { isAxiosError } from 'axios';
import { mostrarAlertaError } from './alert';

/**
 * Manejo de errores con alerta swal
 * @param e Objeto de error devuelto por el catch
 * @param mensaje Mensaje predeterminado
 */
export const manejarErrorAlerta = (e: unknown, mensaje?: string) => {
  // Error documentado por el back
  if (isAxiosError(e)) {
    const mensaje = e?.response.data.mensaje;
    if (mensaje) {
      mostrarAlertaError(mensaje);
      return;
    }
  }
  // Error predeterminado
  mostrarAlertaError(mensaje || 'Hubo un error al realizar la accion');
  console.error(e);
};

/**
 * Manejo de errores con estados de react
 * @param e Objeto de error devuelto por el catch
 * @param callback Dispatch del error obtenido
 * @param mensaje Mensaje predeterminado
 */
export const manejarErrorTexto = (
  e: unknown,
  callback: (mensaje: string) => void,
  mensaje?: string
) => {
  if (isAxiosError(e)) {
    const mensaje = e?.response.data.mensaje;
    if (mensaje) {
      callback(mensaje);
      return;
    }
  }

  callback(mensaje || 'Hubo un error al realizar la accion');
};
